// --
import React from 'react';
import classNames from 'classnames';
import './HorizontalLoader.scss';

/**
 * Loader pro načítání dat - horizontální, typicky pro dlouhé seznamy položek apod.
 */
export default class HorizontalLoader extends React.Component {

    static propTypes = {
        hover: React.PropTypes.bool// pokud je true, jedná se o loader, který není jako standardní div, ale objeví se NAD ostatními elementami, napřo pro využití v seznamech apod
    };

    render() {
        const {className, hover, ...other} = this.props;

        const clsCont = classNames(
            "loaderInf-container",
            className, {
                hover
            }
        );
        const cls = classNames(
            "loaderInf",
        );
        return (
            <div className={clsCont}>
                <div className={cls} {...other}>
                </div>
            </div>
        );
    }

};
